export const PALETTE = {
  void: "#070908",
  black: "#101310",
  iron: "#2a302a",
  steel: "#465048",
  paleSteel: "#788074",
  moss: "#364a36",
  rust: "#6f3a25",
  darkRust: "#3d2119",
  amber: "#e89b32",
  red: "#d43c2f",
  toxic: "#6aa83d",
  toxicBright: "#b9e84f",
  cyan: "#47d8c5",
  bone: "#b9ad8b",
  ash: "#55515b",
  violet: "#67435c",
} as const;
